import about from "../../assets/images/about/about.jpg"
const aboutDataArabic = {
    aboutUsCmsData: {
        page_heading: 'خدماتنا',
        title: "قصتنا",
        breadcrumb: [
            { name: "إتصل بنا", className: "breadcrumb-item", link: "/" },
            { name: "الصفحة", className: "breadcrumb-item", link: "#" },
            { name: "خدماتنا", className: "breadcrumb-item active" },
        ],
        img: about,
        our_story: {
            title: 'قصتنا',
            video_id: 'L61p2uyiMSo',
            img_url: 'about.jpg',
            description: [
                {
                    content: 'انطلق في رحلة مع ',
                    highlight: false,
                },
                {
                    content: 'شركه سبل الاعمال ',
                    highlight: true,
                },
                {
                    content:
                        "شريكك في خلق إرث من الراحة والابتكار. تأسست في عام 2012، نحن نذهب إلى ما هو أبعد من مجرد توفير حلول تكييف الهواء؛ نحن نعمل على توليد الوعي، قصتنا منسوجة بالتفاني والخبرة. التزامنا حقيقي منذ بدايتنا في 2012، اعتنقنا في (شركه سبل الاعمال) روح التقدم والجودة ونتطور تمامًا مع تطور صناعة تكييف الهواء منذ بدايتها في القرن التاسع عشر. انضم إلينا في تشكيل مستقبل التحكم في المناخ.",
                    highlight: false,
                },
            ],
        },
        key_features: {
            description: [
                {
                    content: 'استمتع بقوة تكنولوجيا تكييف الهواء (HVAC) المتطورة مع ',
                    highlight: false,
                },
                {
                    content: 'شركه سبل الاعمال ',
                    highlight: true,
                },
                {
                    content:
                        'تم تصميم حلولنا لتحسين التحكم في المناخ وتحسين جودة الهواء وتوفير أنظمة ذكية موفرة للطاقة. ومن خلال إمكانية الوصول عن بعد وخدمات الصيانة الاحترافية، فإننا نضمن الراحة على مدار العام. ثق في ميزات الأمان الموثوقة لدينا واستمتع بضمان رضا العملاء.',
                    highlight: false,
                },
            ],
            key_features_list: [
                {
                    icon: 'thermometer',
                    title: 'التحكم الفعال في المناخ',
                },
                {
                    icon: 'wind',
                    title: 'تحسين جودة الهواء',
                },
                {
                    icon: 'cpu',
                    title:'حلول تكييف الهواء الذكية',
                },
                {
                    icon: 'wifi',
                    title: 'الوصول والتحكم عن بعد',
                },
                {
                    icon: 'zap',
                    title: 'الأنظمة الموفرة للطاقة',
                },
                {
                    icon: 'tool',
                    title: 'خدمات صيانة متخصصة',
                },
                {
                    icon: 'sun',
                    title: 'راحة على مدار العام',
                },
                {
                    icon: 'shield',
                    title: 'ميزات أمان موثوقة',
                },
                {
                    icon: 'thumbs-up',
                    title: 'ضمان رضا العملاء',
                },
                {
                    icon: 'user-check',
                    title: 'الفنيين المعتمدين',
                },
                {
                    icon: 'cloud-snow',
                    title: 'تقنية التبريد التكيفية',
                },
                {
                    icon: 'headphones',
                    title: 'دعم العملاء على مدار 24 ساعة طوال أيام الأسبوع',
                },
                {
                    icon: 'globe',
                    title: 'حلول التدفئة والتهوية وتكييف الهواء العالمية',
                },
                {
                    icon: 'clock',
                    title: 'خطط الصيانة المجدولة',
                },
                {
                    icon: 'bar-chart',
                    title: 'مقاييس الأداء الأمثل',
                },
            ],
        },
        seeMore: "رؤية المزيد",
        hideMore: "إخفاء المزيد",
    },
};


export { aboutDataArabic }